import ajax from './ajax'
let dataUrl = process.env.VUE_APP_BASEURL;

export const abort = () => {
  return ajax.abort()
}

export const init = () => {
  const result = {
    lang: 'jp'
  }
  const path = dataUrl + 'akakuro/index/index'
  return ajax.post(path, result)
}

export const newsList = (id, page) => {
  const result = {
    lang: 'jp',
    channel_id: id,
    page
  }
  const path = dataUrl + 'akakuro/index/list'
  return ajax.post(path, result)
}

export const newsDetail = (id) => {
  const result = {
    lang: 'jp',
    id
  }
  const path = dataUrl + 'akakuro/index/detail'
  return ajax.post(path, result)
}

// 预约报名
export const apply = (email, apply_time_cus) => {
  const result = {
    lang: 'jp',
    email,
    apply_time_cus  // 注册时间
  }
  const path = dataUrl + 'akakuro/apply/apply'
  return ajax.post(path, result)
}

// 协议详情
export const protocolDetail = (id) => {
  const result = {
    lang: 'jp',
    id
  }
  const path = dataUrl + 'akakuro/article/detail'
  return ajax.post(path, result)
}
